import {SportstypeSpec} from "../types";
import start from "../../icons/tabletennis/start";
import end from "../../icons/tabletennis/end";
import setWin from "../../icons/tabletennis/set-win";
import ace from "../../icons/tabletennis/ace";
import main from "../../icons/tabletennis/main";

const tabletennis: SportstypeSpec = {
  id: 'tabletennis',
  scoreboardType: 'set-based-scoreboard',
  svg: main,
  releaseStage: 'alpha',
  phases: ['pregame', {id: 'set', max: 7}, 'postgame'],
  events: [
    {
      id: 'start',
      important: true,
      svg: start
    },
    {
      id: 'end',
      important: true,
      svg: end
    },
    {
      id: 'set-win',
      important: true,
      svg: setWin
    },
    {
      id: 'ace',
      important: true,
      svg: ace
    }
  ]
}

export default tabletennis
